// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_AprovarDeparaInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract de POST /migration/catalogo/depara
 * (controllers/migration/catalogo.php::depara).
 *
 * Confirma para onde um VALOR do Zoho vai. Cada decisao e um trio:
 *
 *   papel         'servico' | 'prioridade' | 'adicional' | 'produto'
 *   chave_origem  o valor normalizado da origem ('express-ultra', 'Express')
 *   destino_id    o id da linha NOSSA que ele passa a significar
 *
 * NAO HA CAMPO DE TABELA, e a ausencia e deliberada: a tabela sai do `papel`
 * no servidor (CatalogoMigrationService::DESTINOS). Aceitar um nome de tabela
 * vindo do corpo do pedido transformaria "aprovar um de-para" em escrita
 * arbitraria em qualquer tabela do banco.
 *
 * `destino_id` e int e nao string — ao contrario dos ids do Zoho, este e um
 * id NOSSO de auto_increment, que cabe em 2^53 com folga (armadilha A1 nao se
 * aplica neste sentido).
 */
import type { Migration_DeparaDecisaoRow } from './Migration_DeparaDecisaoRow'
import { registerContract } from './validate'

export interface Migration_AprovarDeparaInput {
decisoes?: Migration_DeparaDecisaoRow[]
}

registerContract('Migration_AprovarDeparaInput', {
  decisoes: {
    type: 'array',
    required: false,
    items: {
      papel:        { type: 'string',  required: false },
      chave_origem: { type: 'string',  required: false },
      destino_id:   { type: 'number',  required: false },
    },
  },
})
